"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFontSize = getFontSize;
exports.getLetterSpacing = getLetterSpacing;
exports.convertThemeToMaterial = convertThemeToMaterial;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _core = require("@material-ui/core");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getFontSize(fontSize, baseFontSize) {
  if (typeof baseFontSize !== 'number' || isNaN(baseFontSize) || baseFontSize <= 0) throw new Error('getFontSize error, baseFontSize must be a number greater than 0');
  return fontSize && typeof fontSize === 'number' && fontSize > 0 ? "".concat(baseFontSize * fontSize / 10, "rem") : "".concat(baseFontSize / 10, "rem");
}

function getLetterSpacing(letterSpacing, fallbackLetterSpacing) {
  if (typeof fallbackLetterSpacing !== 'number' || isNaN(fallbackLetterSpacing)) throw new Error('getLetterSpacing error, fallbackLetterSpacing must be a number');
  return typeof letterSpacing === 'number' && !isNaN(letterSpacing) ? "".concat(letterSpacing, "rem") : "".concat(fallbackLetterSpacing, "rem");
}

function getResponsiveFontConfig(font, baseFontSize) {
  var keys = Object.keys(font).filter(function (key) {
    return key.match(/^@/);
  });
  var responsiveConfig = {};
  keys.forEach(function (key) {
    responsiveConfig[key] = _objectSpread({}, font[key]);
    if (responsiveConfig[key].fontSize !== undefined) responsiveConfig[key].fontSize = getFontSize(responsiveConfig[key].fontSize, baseFontSize);
  });
  return responsiveConfig;
}
/**
 * Converts theme object from @input-output-hk/front-end-themes
 * to Material UI (@material-ui/core) theme
 *
 * @param {Object} theme The theme from @input-output-hk/front-end-themes
 * @returns {Object}
 */


function convertThemeToMaterial(theme) {
  return (0, _core.createMuiTheme)(_objectSpread({}, theme, {
    name: theme.name,
    overrides: _objectSpread({}, theme.overrides || {}, {
      MuiSvgIcon: _objectSpread({}, theme.overrides && theme.overrides.MuiSvgIcon || {}, {
        root: _objectSpread({}, theme.overrides && theme.overrides.MuiSvgIcon && theme.overrides.MuiSvgIcon.root || {}, {
          width: '1.4em',
          height: '1.4em'
        })
      })
    }),
    palette: _objectSpread({}, theme.colors, {
      type: theme.type
    }),
    typography: _objectSpread({}, theme.typography, {
      htmlFontSize: theme.typography.baseFontSize,
      h1: _objectSpread({}, theme.typography.h1, {
        letterSpacing: getLetterSpacing(theme.typography.h1.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h1.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h1, theme.typography.baseFontSize)),
      h2: _objectSpread({}, theme.typography.h2, {
        letterSpacing: getLetterSpacing(theme.typography.h2.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h2.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h2, theme.typography.baseFontSize)),
      h3: _objectSpread({}, theme.typography.h3, {
        letterSpacing: getLetterSpacing(theme.typography.h3.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h3.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h3, theme.typography.baseFontSize)),
      h4: _objectSpread({}, theme.typography.h4, {
        letterSpacing: getLetterSpacing(theme.typography.h4.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h4.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h4, theme.typography.baseFontSize)),
      h5: _objectSpread({}, theme.typography.h5, {
        letterSpacing: getLetterSpacing(theme.typography.h5.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h5.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h5, theme.typography.baseFontSize)),
      h6: _objectSpread({}, theme.typography.h6, {
        letterSpacing: getLetterSpacing(theme.typography.h6.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.h6.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.h6, theme.typography.baseFontSize)),
      body1: _objectSpread({}, theme.typography.body, {
        letterSpacing: getLetterSpacing(theme.typography.body.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.body.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.body, theme.typography.baseFontSize)),
      body2: _objectSpread({}, theme.typography.body, {
        letterSpacing: getLetterSpacing(theme.typography.small.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.small.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.small, theme.typography.baseFontSize)),
      button: _objectSpread({}, theme.typography.button, {
        letterSpacing: getLetterSpacing(theme.typography.button.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.button.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.button, theme.typography.baseFontSize)),
      caption: _objectSpread({}, theme.typography.caption, {
        letterSpacing: getLetterSpacing(theme.typography.caption.letterSpacing, theme.typography.letterSpacing),
        fontSize: getFontSize(theme.typography.caption.fontSize, theme.typography.baseFontSize)
      }, getResponsiveFontConfig(theme.typography.caption, theme.typography.baseFontSize))
    }),
    spacing: function spacing(factor) {
      return "".concat(factor, "rem");
    }
  }));
}